export default __webpack_public_path__ + "static/media/cardimg2.1b88f4b1.png";